import { Box, Image } from '@everlywell/ui-kit';
import { SectionHeader } from 'components/SectionHeader';
import React from 'react';

const ImageSection = ({ title, headline }: any) => (
  <Box py={['3rem', '4rem', '4rem']}>
    <SectionHeader eyebrow={title} title={headline} titleMaxWidth="800px" />
    <Image
      src="https://images.ctfassets.net/6huuyzvsw0nv/2nzfx7pPvy9EDRksNI5WDO/3800f0fc3a29b179908dbb41f1cdfa29/reporting.jpg"
      alt="Reporting"
      width="100%"
      maxWidth="976px"
      mx="auto"
      mt={12}
    />
  </Box>
);

export default ImageSection;
